export default "__VITE_ASSET__Bj3nU1HZ__"